import { CalendarDays } from 'lucide-react';

import { BOOKING_STATUS_LABELS } from '@repo/shared-types';

import { NodeShell } from './NodeShell';

import type { BookingNodeData } from '@repo/shared-types';

export const BookingNode = ({ data, selected }: { data: BookingNodeData; selected?: boolean }) => {
  const subtitle = data.action
    ? data.action === 'add'
      ? `Add booking${data.time ? ` @ ${data.time}` : ''}`
      : data.action === 'set_status'
        ? `Mark ${BOOKING_STATUS_LABELS[data.status ?? 'cancelled'].toLowerCase()}`
        : 'Cancel booking'
    : undefined;

  return (
    <NodeShell
      type="booking"
      icon={<CalendarDays size={16} />}
      label={data.label}
      subtitle={subtitle}
      selected={selected}
    />
  );
};
